import type { ComponentMobileKeyMap, ComponentMobileMap, MainHomeMobileProps } from './types';

export const parseRootMobileProps = (props: MainHomeMobileProps['props']): ComponentMobileMap => {
	const returnValue: ComponentMobileMap = {};

	const componentsNames: Record<string, ComponentMobileKeyMap> = {
		'm-list-card-simple': 'mListCardSimpleHover',
		'm-card-image-carousel': 'mCardImageCarousel',
		'm-card-multiproduct-carousel': 'mCardMultiproductCarousel',
		'm-features': 'mFeatures',
		'm-section-image-link': 'mSectionImageLink',
		'm-comarketing': 'mComarketing',
		'm-collapse-links-products': 'mCollapseLinksProducts',
		'm-tabs-campaign': 'tabsProductCard',
		'm-trustedshops': 'mTrustedShops',
		'm-blog': 'mBlog',
		'm-banner-button-width': 'mBannerButtonWidth',
		'm-last-news': 'mLastNews',
		'm-tabs-searchers': 'mTabsSearchers',
		'm-coasts': 'mCoasts',
	};

	Object.entries<any>(props).forEach(([propsKey, propsValue]) => {
		if (!propsValue) return;

		const { name } = propsValue;
		const key = componentsNames[name];
		if (key) returnValue[key] = propsValue;
		else if (typeof propsValue === 'object') returnValue[propsKey as ComponentMobileKeyMap] = propsValue;
	});

	return returnValue;
};
